import { viewsActions } from '../../services';

export const viewsStateDispatcher = dispatch => ( {
  changeView: ( key, viewType ) => dispatch( { type: viewsActions.CHANGEVIEW, viewType, key } )
} );
